export enum PersonalizationPopup {
  Root = 'personalization-popup',
}

export enum EmailTemplateThumbnailsRouting {
  Root = 'email-template-thumbnails',
}

export enum RegistrationRouting {
  Root = 'registration',
  Register = 'register',
  Step1 = 'step-1',
  Step2 = 'step-2',
  Step3 = 'step-3',
  ThankYou = 'thank-you',
}
export enum CredentialsRouting {
  Root = 'credentials',
  Current = 'current',
  Loader = 'loading',
  SelectAuth = 'select-auth',
  UpdateEmail = 'update-email',
  Update = 'update',
  ServicePrincipalAuth = 'service-principal-auth',
  UsernamePassword = 'username-password',
  ApplicationUser = 'application-user',
}

export enum CommerceConfigurationsRouting {
  Root = 'commerce-configurations',
  ConnectorConfiguration = 'connector-configuration',
  AddConnector = 'add-connector',
  Connector = 'connector',
  CreateConnectorRedirect = 'create-connector-redirect',
  CreateShopifyConnector = 'shopify',
}

export enum ManualSynchronizationRouting {
  Root = 'manual-synchronization',
}

// export enum SocialMarketingRouts {
//   Root = 'social-marketing',
//   Loader = 'loader',
//   Welcome = 'welcome',
//   CreateAccountOwner = 'create-account-owner',
//   ConfigureCName = 'configure-cname',
//   Congratulation = 'congratulation',
//   UpdateAccountOwner = 'update-account-owner',
// }

// export enum SocialProfileConfigurationsRouts {
//   Root = 'social-profile-configurations',
//   Connectors = 'connectors',
//   CreateConnector = 'create-connector',
//   CreateConnectorConnect = 'create-connector-connect',
// }

export enum RegExpValidations {
  // tslint:disable-next-line:quotemark
  NameValidation = "^([a-zA-Z]{1,}'?-?[a-zA-Z]{2,}s?([a-zA-Z]{1,})?)$",
  EmailValidation = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}',
  DomainValidation = '^[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9-]+)*([-.]{1})[a-zA-Z]{2,10}$',
  DomainValidationHttps = '^(http(s|)://)[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9-]+)*([-.]{1})[a-zA-Z]{2,10}$',
  DomainValidationCrmUrl = '^(http(s|)://)[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9-]+)*([-.]{1})[a-zA-Z]{2,10}(/|/[a-z]+|)(:[0-9]+(/|/[a-zA-Z]+(/|)|)|)$',
}
